import React, {Suspense, lazy} from "react";
import {Redirect, Switch, Route} from "react-router-dom";
import {LayoutSplashScreen} from "../_metronic/layout";

const AppPage = lazy(() =>
  import("./modules/App/pages/AppPage")
);

export default function BasePage() {
    // useEffect(() => {

    // }, []) // [] - is required if you need only one call
    // https://reactjs.org/docs/hooks-reference.html#useeffect

    return (
        <Suspense fallback={<LayoutSplashScreen/>}>
            <Switch>
                {
                  /* Redirect from root URL to /dashboard. */
                  <Redirect exact from="/" to="/app/customers"/>
                }
                <Route path="/app" component={AppPage}/>
                <Redirect to="error/error-v1"/>
            </Switch>
        </Suspense>
    );
}